module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-page"
  }, [_c('DashboardHeader', {
    attrs: {
      "nombre": _vm.nombreUsuario
    }
  }), _c('Noticias'), _c('br'), _c('div', {
    staticClass: "dashboard-info-grid"
  }, [_c('NuevosEmpleados'), _c('CumpleaniosHoy')], 1), _c('MisCursos'), _c('br'), (_vm.perfilVacaciones !== 'usuario') ? _c('PendientesJefe') : _vm._e(), _c('MisPendientes')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14802068","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Component_Dashboard_KPI_jefe_New.vue
// module id = 828
// module chunks = 0